module.exports = __webpack_public_path__ + "img/n2.30dc076b.png";